import { jsx as _jsx } from "react/jsx-runtime";
import { Combobox } from '../../../combobox/src';
export const TimePickerInput = ({ type, label, value, onChange, options, hasError, required, disabled, }) => {
    const isTimeZoneInput = type === 'timeZoneName';
    return (_jsx(Combobox, { label: label, noOptionsFoundLabel: '', value: value, onChange: (value) => onChange(value, type), options: options, hasError: hasError, size: isTimeZoneInput ? 'full' : 'xs', required: required, dropdownFitsContent: isTimeZoneInput, disabled: disabled }));
};
//# sourceMappingURL=time_picker_input.js.map